import { defineQuery } from 'groq';

export const latestAlertingChangelogEntriesQuery = defineQuery(`
*[_type == "changelog"
  && mgApp == $mgApp
  && language == $language
  && $country in countries
  && $consumer in publishToGroups[]->value
  && alertingDatetimeRange.startDate < now()
  && alertingDatetimeRange.endDate > now()
  ]
  | order(changeDate desc)
  {
   "id": _id,
   title,
   changeDate,
   tags,
   "content": content[] {
     ...,
     _type == "image" => {
       ...,
       "asset": asset-> { _id, url }
     }
   },
  }
 `);

export const changelogEntryQuery = defineQuery(`
*[_type == "changelog" && slug.current == $slug]
  {
   "id": _id,
   title,
   changeDate,
   tags,
   "content": content[] {
     ...,
     _type == "image" => {
       ...,
       "asset": asset-> { _id, url }
     }
   },
  }[0]
`);

export const paginatedChangelogEntriesQuery = defineQuery(`
*[_type == "changelog"
  && mgApp == $mgApp
  && language == $language
  && $country in countries
  && $consumer in publishToGroups[]->value
  && dateTime(changeDate) <= dateTime(now())
]
| order(changeDate desc)
{
  "id": _id,
  title,
  changeDate,
  tags,
  "content": content[] {
     ...,
     _type == "image" => {
       ...,
       "asset": asset-> { _id, url }
     }
   },
}
[$offset...$end]
`);

export const latestChangelogEntriesIdsQuery = defineQuery(`
*[_type == "changelog"
  && mgApp == $mgApp
  && language == $language
  && $country in countries
  && $consumer in publishToGroups[]->value
  && dateTime(changeDate) > dateTime($minChangeDate)
  && dateTime(changeDate) <= dateTime(now())
]
{
  "id": _id
}
`);
